
export interface QuoteTotals {
  subtotal: number;
  taxAmount: number;
  totalAmount: number;
}

export function computeQuoteTotals(
  items: { unitPrice: number; quantity: number }[],
  discountPct: number,
  discountAmount: number,
  taxRate: number,
  shippingCharge: number,
  discountAppliesAfterTax: boolean,
): QuoteTotals {
  const nn = (n: number) => (Number.isFinite(n) && n > 0 ? n : 0);
  const clamp01 = (n: number) => Math.min(1, Math.max(0, nn(n)));

  let subtotal = 0;
  for (const it of items) {
    subtotal += nn(it.unitPrice) * Math.max(1, Math.floor(nn(it.quantity)) || 1);
  }

  const pct = clamp01(discountPct);
  const flat = nn(discountAmount);
  const tax = clamp01(taxRate);
  const ship = nn(shippingCharge);

  if (discountAppliesAfterTax) {
    const taxAmount = subtotal * tax;
    const preDiscount = subtotal + taxAmount;
    const discounted = Math.max(0, preDiscount - (preDiscount * pct + flat));
    return { subtotal, taxAmount, totalAmount: discounted + ship };
  }

  const discountedSub = Math.max(0, subtotal - (subtotal * pct + flat));
  const taxAmount = discountedSub * tax;
  return { subtotal, taxAmount, totalAmount: discountedSub + taxAmount + ship };
}

export function formatMoney(value: number): string {
  return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
}
